import { apiSecurityList } from './api'
import { runSecurityFlow } from './orchestrator'
import useUserStore from '@/store/user'
import { decidePasskeyType } from './utils'

export const MFAService = {
  _map: new Map<string, true>(),
  _fetchedAt: 0,
  _ttlMs: 3_000,

  async isRequired(code: string) {
    const now = Date.now()
    if (this._map.size === 0 || now - this._fetchedAt > this._ttlMs) {
      const list = await apiSecurityList()
      this._map = new Map(list.map((i) => [i.model_value, true]))
      this._fetchedAt = now
    }
    return this._map.has(code)
  },

  async ensure(
    code: string,
    opts?: {
      title: string
      credentialType?: '1' | '2'
      payload?: any
    },
  ) {
    let credential = undefined
    let hasVerifyPhone = false
    let hasBindApp = false
    let hasBindPasskey = false
    let hasBindGooglePasskey = false
    let hasBindApplePasskey = false

    if (code === 'remote_login') {
      credential = opts?.payload?.data?.credential ?? []
      hasVerifyPhone = opts?.payload?.data?.phone_verify
      hasBindApp = opts?.payload?.data?.bind_google_secret == 1
      hasBindPasskey =
        Array.isArray(opts?.payload?.data?.credential) &&
        opts?.payload?.data?.credential?.length > 0
      hasBindGooglePasskey =
        hasBindPasskey && opts?.payload?.data?.credential?.join(',').includes('2')
      hasBindApplePasskey =
        hasBindPasskey && opts?.payload?.data?.credential?.join(',').includes('1')
    } else {
      const userStore = useUserStore()
      await userStore.fetchUserInfo()
      credential = userStore.credential ?? []
      hasVerifyPhone = userStore.hasVerifiedPhone
      hasBindApp = userStore.hasBindApp
      hasBindPasskey = userStore.hasBindPasskey
      hasBindGooglePasskey = userStore.hasBindGooglePasskey
      hasBindApplePasskey = userStore.hasBindApplePasskey
    }
    const credentialType = decidePasskeyType(credential)
    return runSecurityFlow({
      securityCode: code,
      title: opts?.title ?? '',
      credentialType,
      payload: opts?.payload,
      verifyStatusMap: {
        sms_validate: hasVerifyPhone,
        app_validate: hasBindApp,
        biometric_validate: hasBindPasskey,
        google_passkey: hasBindGooglePasskey,
        apple_passkey: hasBindApplePasskey,
      },
    })
  },
}
